// #region Imports

import Vue from 'vue';
import IoShopCalculator from '@/shop/IoShopCalculator.vue';

// #endregion

// #region Component Registration

Vue.component('IoShopCalculator', IoShopCalculator);

// #endregion
